import { render } from "./RoutePoint.vue?vue&type=template&id=62456af5&scoped=true"
import script from "./RoutePoint.vue?vue&type=script&lang=js"
export * from "./RoutePoint.vue?vue&type=script&lang=js"

import "./RoutePoint.vue?vue&type=style&index=0&id=62456af5&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62456af5"]])

export default __exports__